module.exports = __webpack_public_path__ + "media/images/pic/team-4fc74c40bb8c53375b1d80bde0fd04b7.webp";